<template>
  <div :style="style" class="control-container">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <table class="table">
            <tr v-for="(row,index) in control.data.data.rows" :key="index">
                <td class="td-label">
                    <div style="display: flex;align-items: center;">
                        <div v-if="row">
                            <CktextComponent :rawHtml="row.label">    
                            </CktextComponent>
                        </div>
                        <div v-if="row.required" class="required">*</div>
                    </div>
                </td>
                <td class="td-default" :class="{'invalid-cell':submitted&&!cellsvalid[index]}">
                  <input type="text" v-model="values[row.key]" class="plain-input input-outline-none" :class="{'invalid-cell':submitted&&!cellsvalid[index]}"/>
                </td>
            </tr>
        </table>
    </div>
    <div class="control-row p-error" v-if="(submitted&&!valid)">
      {{$t('message.cells_required')}}
    </div>    
  </div>
</template>

<script>
import CktextComponent from '../CkText.vue';

export default {
  name: 'TableControl',
  components: {
    CktextComponent
  },
  data(){
    return {
      style:'',
      values:{},
      valid:false,
      cellsvalid:[],
      submitted:false
    }
  },
  props: {
    control: null
  },
  methods:{
    validateData(){

      this.submitted=true;

      this.valid=true;

      this.cellsvalid=[];

      for(var i=0; i<this.control.data.data.rows.length;i++){

        if(this.values[this.control.data.data.rows[i].key].trim()==""&&this.control.data.data.rows[i].required){

          this.cellsvalid.push(false);

          this.valid=false;

        }
        else
          this.cellsvalid.push(true);

      }

      return {
        valid:this.valid,
        data:this.values,
        type:5 // json 数据
      };

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

    for(var i=0; i<this.control.data.data.rows.length;i++){

      this.values[this.control.data.data.rows[i].key]=this.control.data.data.rows[i].default;

    }

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
        margin-bottom: 0px;
  }
  .control-row{
        margin-bottom: 10px;
        text-align:left;
  }

  .title{
        display: flex;
  }
  .required{
        color:#f7363f;
  }   
  .table{
        width: 100%;
        background-color: #fbfbfb;
        border-collapse: collapse;  
  }
  .td-label{
        padding: 10px 12px;
        border: 1px solid #d8d8d8;
        width: 150px;
  } 
            
  .td-default{
        background-color: white;
        border: 1px solid #d8d8d8;
        
        
  }
  .plain-input{
          border: hidden;
          padding: 0;
          margin-left: 5px;
          display: inline-block;
          min-height: 1rem;
  }
  .input-outline-none{
      outline: none;
      border-width: 0px;
  }
  
  .invalid-cell{
      background-color:rgba(247,54,63,0.2)
  }
</style>